import { create } from "zustand";

export const useMeetingStore = create((set, get) => ({
  // State
  meetings: [],
  loading: false,
  error: null,
  selectedMeeting: null,
  searchQuery: "",
  filters: {},

  // Table features
  columnFilters: {},
  uniqueValues: {},
  paginationData: {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 0,
  },

  // Modal / UI states
  isFormOpen: false,
  isEditMode: false,
  isDeleteDialogOpen: false,
  isDetailsOpen: false,
  meetingToDelete: null,
  isDetailDialogOpen: false,
  meetingToView: null,

  // Basic Setters
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),

  setMeetings: (meetings) => set({ meetings }),
  setSelectedMeeting: (meeting) => set({ selectedMeeting: meeting }),
  setIsDetailsOpen: (isOpen) => set({ isDetailsOpen: isOpen }),

  setSearchQuery: (searchQuery) => set({ searchQuery }),
  setFilters: (filters) => set({ filters }),
  setColumnFilters: (columnFilters) => set({ columnFilters }),
  setUniqueValues: (uniqueValues) => set({ uniqueValues }),

  setPagination: (data) => set((state) => ({
    paginationData: {
      ...state.paginationData,
      ...data,
      currentPage: data.page || data.currentPage || state.paginationData.currentPage,
      itemsPerPage: data.pageSize || data.itemsPerPage || state.paginationData.itemsPerPage,
      totalItems: data.total || data.totalItems || state.paginationData.totalItems,
      totalPages: data.totalPages || state.paginationData.totalPages,
    }
  })),

  // UI Flow Actions
  openCreateForm: () => set({
    isFormOpen: true,
    isEditMode: false,
    selectedMeeting: null,
    error: null
  }),

  openEditForm: (meeting) => set({
    isFormOpen: true,
    isEditMode: true,
    selectedMeeting: meeting,
    error: null
  }),

  closeForm: () => set({
    isFormOpen: false,
    selectedMeeting: null,
    error: null
  }),

  openDeleteDialog: (meeting) => set({
    isDeleteDialogOpen: true,
    meetingToDelete: meeting,
    error: null
  }),

  closeDeleteDialog: () => set({
    isDeleteDialogOpen: false,
    meetingToDelete: null,
    error: null
  }),

  openDetailDialog: (meeting) => set({
    isDetailDialogOpen: true,
    meetingToView: meeting,
    error: null
  }),

  closeDetailDialog: () => set({
    isDetailDialogOpen: false,
    meetingToView: null,
    error: null
  }),
}));
